export default "__VITE_ASSET__DPkaQ_TX__"